import React from "react";
import moment from "moment";
import { Accordion, Row, Col, Stack } from "react-bootstrap";
import PropTypes from "prop-types";

function WorkOrderContractInfoItem({ contractInfoItem }) {
  const contractInfoItemView = (
    <Row>
      <Col xs="3">
        <strong>Equipment Covered</strong>
        <ul>
          {contractInfoItem.equipmentCovered.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Col>
      <Col xs="3">
        <strong>Allowed Callers</strong>
        <ul>
          {contractInfoItem.allowedCallers.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Col>
      <Col xs="3">
        <strong>Out Of Hours Support</strong>
        <ul>
          <li>{contractInfoItem.outOfHoursSupport}</li>
        </ul>
      </Col>
      <Col xs="3">
        <strong>Purchase Order</strong>
        <ul className="list-unstyled">
          <li>
            <span>Required: </span>
            {contractInfoItem.purchaseOrderRequired
              ? "Call Take"
              : "Not Required"}
          </li>
          {contractInfoItem.purchaseOrder && (
            <li>
              <span>PO: </span>
              {contractInfoItem.purchaseOrder}
            </li>
          )}
          {contractInfoItem.purchaseOrderExpire && (
            <li>
              <span>Expiry: </span>
              {moment(contractInfoItem.purchaseOrderExpire).format(
                "DD-MM-YYYY"
              )}
            </li>
          )}
        </ul>
      </Col>
    </Row>
  );

  const view = (
    <Accordion.Item eventKey={contractInfoItem.contractId}>
      <Accordion.Header>
        <Stack gap={2}>
          <div>
            <b>Client:</b> {contractInfoItem.clientName}
          </div>
          <div>
            <b>Type:</b> {contractInfoItem.contractType}
          </div>
        </Stack>
      </Accordion.Header>
      <Accordion.Body>{contractInfoItemView}</Accordion.Body>
    </Accordion.Item>
  );

  return view;
}

WorkOrderContractInfoItem.propTypes = {
  contractInfoItem: PropTypes.shape({
    equipmentCovered: PropTypes.arrayOf(PropTypes.string),
    allowedCallers: PropTypes.arrayOf(PropTypes.string),
    purchaseOrderRequired: PropTypes.bool,
    outOfHoursSupport: PropTypes.string,
    contractId: PropTypes.number,
    clientName: PropTypes.string,
    contractType: PropTypes.string,
    purchaseOrder: PropTypes.string,
    purchaseOrderExpire: PropTypes.string,
  }).isRequired,
};

export default WorkOrderContractInfoItem;
